import { createContext, FC, ReactNode } from 'react'
import s from './Cover.module.sass'
import CoverMain from '@shared/ui/Layout/Cover/CoverMain'
import CoverAside from '@shared/ui/Layout/Cover/CoverAside'
import { ContainerLong } from '@shared/ui/Layout/Containers/ContainerLong'
import { BlockBoundary } from '../../../lib/components/BlockBoundary'

export const ImgContext = createContext('')
export const ObjectIdContext = createContext<number | undefined>(undefined)

interface Props {
  img: string
  objectId?: number
  children: ReactNode
  classNameContainer?: string
  classNameContent?: string
}

const Cover: FC<Props & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>> = ({
  children,
  img,
  objectId,
  classNameContainer = '',
  classNameContent = '',
  ...props
}) => {
  return (
    <BlockBoundary>
      <ImgContext.Provider value={img}>
        <ObjectIdContext.Provider value={objectId}>
          <ContainerLong
            tag={'section'}
            classNameContainer={`${s.container} ${classNameContainer}`}
            classNameContent={`${s.content} ${classNameContent}`}
            {...props}>
            {children}
          </ContainerLong>
        </ObjectIdContext.Provider>
      </ImgContext.Provider>
    </BlockBoundary>
  )
}

const CoverNamespace = Object.assign(Cover, {
  Main: CoverMain,
  Aside: CoverAside,
})

export default CoverNamespace
